import React from "react";

import authService from "../services/authService";

import SuperAdminDashboard from "./Dashboard/SuperAdminDashboard";
import DealerDashboard from "./Dashboard/DealerDashboard";
import ShopDashboard from "./Dashboard/ShopDashboard";
import PlayerDashboard from "./Dashboard/PlayerDashboard";

const Dashboard = () => {
  const user = authService.getCurrentUser();

  switch (user?.role) {
    case "SUPER_ADMIN":
      return <SuperAdminDashboard />;

    case "DEALER":
      return <DealerDashboard />;

    case "SHOP":
      return <ShopDashboard />;

    case "PLAYER":
      return <PlayerDashboard />;

    default:
      return null;
  }
};

export default Dashboard;